import Vue from "vue";

Vue.prototype.$globalNav = [
  {
    name: "使い方",
    to: "/",
  },
  {
    name: "メリット",
    to: "/",
  },
  {
    name: "サンプル",
    to: "/",
  },
  {
    name: "Login",
    to: "/login",
  },
  {
    name: "Register",
    to: "/register",
  },
];
Vue.prototype.$salesNav = [
  {
    name: "Dashboard",
    to: "/sales/",
    icon: "mdi-view-dashboard",
    exact: true,
  },
  {
    name: "Ticket",
    to: "/sales/ticket",
    icon: "mdi-ticket-confirmation",
    exact: false,
  },
  {
    name: "Member",
    to: "/sales/member",
    icon: "mdi-account-circle",
    exact: false,
  },
  {
    name: "Proposal",
    to: "/sales/proposal",
    icon: "mdi-lightbulb-on",
    exact: false,
  },
];
Vue.prototype.$salesSettings = [
  {
    name: "Partner",
    to: "/sales/partner",
    icon: "mdi-domain",
  },
  {
    name: "Offer",
    to: "/sales/offer",
    icon: "mdi-file-sign",
  },
  {
    name: "Setting",
    to: "/sales/setting",
    icon: "mdi-cog",
  },
  {
    name: "Logout",
    to: "/logout",
    icon: "mdi-logout",
  },
];
